import { Flex, Tag } from "@chakra-ui/react";
import type { Consultant } from "@models/Consultant";
import ConsultantImage from "@components/ConsultantImage";

const FinalizedConsultantItem = ({ firstName, hasCustomerExperience, profile }: Consultant) => {
	return (
		<Flex my={2} direction={"column"} alignItems={"center"}>
			<ConsultantImage url={profile?.profilePicture} name={firstName} size="75px" placeholderFontSize="11px" />
			{hasCustomerExperience && (
				<Tag size="sm" bg={"#4BB769"} color={"#FFFFFF"} width={"fit-content"}>
					Tidigare anlitad
				</Tag>
			)}
		</Flex>
	);
};

export default FinalizedConsultantItem;
